export default "__VITE_ASSET__Jtw4Zild__"